﻿// future: support many storage strategies
import $ from 'jquery';
import { Element } from "./element";
import { Storage } from "./storage";

declare global {
  interface JQuery {
    eventnotifier(option, args) : any;
  }
}

export class EventNotifier {
  public static get wireup(): string { return this.wireupName.asDataSelector(); }
  public static get wireupName(): string { return 'event-notifier'; }

  private $element: JQuery;
  private options: IEventNotifierOptions;

  private DEFAULTS: IEventNotifierOptions = {
    key: null,
    notifyOn: 'change'
  };

  constructor($element: JQuery, options: IEventNotifierOptions) {
    if (!$element || $element.length == 0)
      throw Error('You must provide an element to Rustig.EventNotifier');

    this.$element = $element;
    this.options = $.extend({}, this.DEFAULTS, this.options, this.$element.data());
    this.options.key = this.options.key || this.$element.data(EventNotifier.wireupName);

    if (!this.options.key)
      throw Error('You must provide a key to Rustig.EventNotifier');

    this.setEventListener();
  }

  private setEventListener(): void {
    let events = this.options.notifyOn.split(',').map((event: string) => {
      return event.trim() + '.rustig.eventnotifier'
    });

    let eventName = events.join(' ');

    this.$element.on(eventName, () => {
      let subject = new Element(this.$element);

      let value = <IElementProperties>{
        value: subject.value(),
        text: subject.text()
      }

      let oneMinute = 60000;
      Storage.set(this.options.key, value, oneMinute);
    });
  }
}

export interface IEventNotifierOptions {
  key: string;
  notifyOn: string;
}

export interface IElementProperties {
  value: any;
  text: string;
}

function Plugin(option, args) {
  return this.each(function () {
    var $this = $(this);
    var data = $this.data('rustig.eventnotifier');
    var options = typeof option == 'object' && option;

    if (!data) {
      data = new EventNotifier($this, options);
      $this.data('rustig.eventnotifier', data);
    }
    if (typeof option == 'string')
      data[option](args);
  });
}

$.fn.eventnotifier = Plugin;
